// /**
//  * bsub-dawn-fix.js
//  *
//  * Runtime patch for Bold Subscriptions' widget on Dawn.
//  *
//  * The app's widget script resolves the current variant like this:
//  *
//  *   _getVariantId: function (widget) {
//  *     var productForm = document.querySelector('form[action*="/cart/add"]');  // document-wide!
//  *     return productForm.querySelector('[name="id"]').value;
//  *   }
//  *
//  * It ignores the `widget` argument and takes the FIRST add-to-cart form in the document. Dawn
//  * renders several (cart drawer upsells, related products, product cards), so Bold frequently
//  * reads a variant id that belongs to a different product. That id is not a key in its own
//  * `variants` map, so `this.variants[variantId].price` throws inside an async handler and
//  * `_showWidget()` is never reached — the widget stays stuck on `bsub__hidden`.
//  *
//  * This patch scopes the lookup to the widget's own <form>, and makes an unknown variant id a
//  * no-op instead of an exception.
//  *
//  * Remove this file if Bold ships a fix (track: _getVariantId should use widget.closest('form')).
//  */
// (function () {
//   var MAIN_FORM = 'form[action*="/cart/add"]';

//   function patch(bsub) {
//     if (!bsub || bsub.__dawnFixApplied) return false;

//     bsub._getVariantId = function (widget) {
//       // Prefer the form this widget actually lives in.
//       var form = widget && widget.closest ? widget.closest(MAIN_FORM) : null;

//       // The app block can render outside the form; fall back to the main product section's form.
//       if (!form) {
//         var productInfo = (widget && widget.closest && widget.closest('product-info')) || document.querySelector('product-info');
//         form = productInfo ? productInfo.querySelector(MAIN_FORM) : document.querySelector(MAIN_FORM);
//       }

//       if (!form) {
//         console.error('BSUB [dawn-fix]: no product form found for widget.');
//         return null;
//       }

//       var input = form.querySelector('[name="id"]');
//       return input ? input.value : null;
//     };

//     // `variants[variantId]` is dereferenced unguarded in several places. If Dawn reports no
//     // variant (unavailable option combination) the id is '' and the original code throws,
//     // permanently hiding the widget. Swallow that case instead.
//     var originalHandle = bsub.handleSelectionChange.bind(bsub);
//     bsub.handleSelectionChange = async function (event, widget) {
//       var id = this._getVariantId(widget);
//       if (!id || !this.variants[id]) {
//         console.debug('BSUB [dawn-fix]: skipping, unknown variant id:', id);
//         return;
//       }
//       return originalHandle(event, widget);
//     }.bind(bsub);

//     bsub.__dawnFixApplied = true;
//     return true;
//   }

//   function reinit(bsub) {
//     // init() appends a fresh selling_plan input to every form each time it runs. Strip the ones
//     // from the first (broken) init so the forms don't accumulate duplicates.
//     document.querySelectorAll('[data-bsub-selling-plan-id-input]').forEach(function (el) {
//       el.remove();
//     });
//     bsub.init();
//   }

//   function start() {
//     var tries = 0;
//     var timer = setInterval(function () {
//       var bsub = window.BOLD && window.BOLD.BsubWidget;

//       if (bsub) {
//         clearInterval(timer);
//         if (patch(bsub)) reinit(bsub);
//         return;
//       }

//       // Bold loads from their app extension CDN; give it ~15s before giving up.
//       if (++tries > 100) {
//         clearInterval(timer);
//         console.debug('BSUB [dawn-fix]: widget script never appeared; nothing to patch.');
//       }
//     }, 150);
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', start);
//   } else {
//     start();
//   }
// })();
/**
 * bsub-dawn-fix.js
 *
 * Runtime patch for Bold Subscriptions' widget on Dawn.
 *
 * The app's widget script resolves the current variant like this:
 *
 *   _getVariantId: function (widget) {
 *     var productForm = document.querySelector('form[action*="/cart/add"]');  // document-wide!
 *     return productForm.querySelector('[name="id"]').value;
 *   }
 *
 * It ignores the `widget` argument and takes the FIRST add-to-cart form in the document. Dawn
 * renders several (cart drawer upsells, related products, product cards), so Bold frequently
 * reads a variant id that belongs to a different product. That id is not a key in its own
 * `variants` map, so `this.variants[variantId].price` throws inside an async handler and
 * `_showWidget()` is never reached — the widget stays stuck on `bsub__hidden`.
 *
 * This patch scopes the lookup to the widget's own <form>, and makes an unknown variant id a
 * no-op instead of an exception.
 *
 * Remove this file if Bold ships a fix (track: _getVariantId should use widget.closest('form')).
 */(function () {
  var MAIN_FORM = 'form[action*="/cart/add"]';
  var WIDGET_SELECTORS = [
    '[data-bsub-widget]',
    '.bsub-widget',
    '.bold-subscriptions',
    '.bold_subscriptions',
    '[class*="bsub"]'
  ].join(',');

  function getProductInfo(el) {
    return (el && el.closest && el.closest('product-info')) || document.querySelector('product-info');
  }

  function getForm(el) {
    var form = el && el.closest ? el.closest(MAIN_FORM) : null;

    if (!form) {
      var productInfo = getProductInfo(el);
      form = productInfo ? productInfo.querySelector(MAIN_FORM) : document.querySelector(MAIN_FORM);
    }

    return form || null;
  }

  function getVariantId(form) {
    var input = form && form.querySelector('[name="id"]');
    return input && input.value ? input.value : null;
  }

  function getSellingPlanId(form) {
    var input = form && form.querySelector('[name="selling_plan"]');
    return input && input.value ? input.value : null;
  }

  function getWidget(form) {
    if (form) {
      var productInfo = getProductInfo(form);
      if (productInfo) {
        var scopedWidget = productInfo.querySelector(WIDGET_SELECTORS);
        if (scopedWidget) return scopedWidget;
      }
    }
    return document.querySelector(WIDGET_SELECTORS);
  }

  function replaceNodeContent(currentRoot, nextRoot, selectors) {
    for (var i = 0; i < selectors.length; i++) {
      var selector = selectors[i];
      var currentNode = currentRoot.querySelector(selector);
      var nextNode = nextRoot.querySelector(selector);

      if (currentNode && nextNode) {
        currentNode.innerHTML = nextNode.innerHTML;
      }
    }
  }

  function refreshDawnProductInfo(form) {
    var productInfo = getProductInfo(form);
    if (!productInfo) return;

    var variantId = getVariantId(form);
    if (!variantId) return;

    var sectionId = productInfo.dataset.section;
    var productUrl = productInfo.dataset.url;

    if (!sectionId || !productUrl) {
      console.debug('BSUB [dawn-fix]: missing product-info dataset for refresh.');
      return;
    }

    var sellingPlanId = getSellingPlanId(form);
    var url =
      productUrl +
      '?variant=' +
      encodeURIComponent(variantId) +
      '&section_id=' +
      encodeURIComponent(sectionId) +
      (sellingPlanId ? '&selling_plan=' + encodeURIComponent(sellingPlanId) : '');

    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        replaceNodeContent(document, doc, [
          '#price-' + sectionId,
          '#price-per-item-' + sectionId,
          '#Inventory-' + sectionId,
          '#Sku-' + sectionId,
          '#Volume-' + sectionId,
          '#VariantPickup-' + sectionId
        ]);
      })
      .catch(function (err) {
        console.debug('BSUB [dawn-fix]: product info refresh failed.', err);
      });
  }

  function removeDuplicateSellingPlanInputs() {
    document.querySelectorAll('[data-bsub-selling-plan-id-input]').forEach(function (el) {
      el.remove();
    });
  }

  function patch(bsub) {
    if (!bsub || bsub.__dawnFixApplied) return false;

    bsub._getVariantId = function (widget) {
      var form = getForm(widget);

      if (!form) {
        console.error('BSUB [dawn-fix]: no product form found for widget.');
        return null;
      }

      return getVariantId(form);
    };

    if (typeof bsub.handleSelectionChange === 'function') {
      var originalHandleSelectionChange = bsub.handleSelectionChange.bind(bsub);

      bsub.handleSelectionChange = async function (event, widget) {
        var form = getForm(widget);
        var id = form ? getVariantId(form) : null;

        if (!id || !this.variants || !this.variants[id]) {
          console.debug('BSUB [dawn-fix]: skipping, unknown variant id:', id);
          return;
        }

        var result = await originalHandleSelectionChange(event, widget);

        setTimeout(function () {
          refreshDawnProductInfo(form);
        }, 80);

        return result;
      }.bind(bsub);
    }

    bsub.__dawnFixApplied = true;
    return true;
  }

  function triggerBoldRefresh(form) {
    var bsub = window.BOLD && window.BOLD.BsubWidget;
    if (!bsub || typeof bsub.handleSelectionChange !== 'function') return;

    var widget = getWidget(form);

    try {
      bsub.handleSelectionChange(
        {
          type: 'change',
          target: form
        },
        widget
      );
    } catch (e) {
      console.debug('BSUB [dawn-fix]: Bold refresh trigger failed.', e);
    }
  }

  function onVariantChanged(form) {
    var variantId = getVariantId(form);

    if (!variantId) {
      console.debug('BSUB [dawn-fix]: variant unavailable, skipping refresh.');
      return;
    }

    setTimeout(function () {
      triggerBoldRefresh(form);

      setTimeout(function () {
        refreshDawnProductInfo(form);
      }, 120);
    }, 120);
  }

  function onSellingPlanChanged(form) {
    setTimeout(function () {
      refreshDawnProductInfo(form);
    }, 80);
  }

  function bindForm(form) {
    if (!form || form.__bsubDawnFixBound) return;
    form.__bsubDawnFixBound = true;

    var lastVariantId = getVariantId(form);
    var lastSellingPlanId = getSellingPlanId(form);

    form.addEventListener('change', function () {
      var currentVariantId = getVariantId(form);
      var currentSellingPlanId = getSellingPlanId(form);

      if (currentVariantId !== lastVariantId) {
        lastVariantId = currentVariantId;
        lastSellingPlanId = currentSellingPlanId;
        onVariantChanged(form);
        return;
      }

      if (currentSellingPlanId !== lastSellingPlanId) {
        lastSellingPlanId = currentSellingPlanId;
        onSellingPlanChanged(form);
      }
    });

    var variantInput = form.querySelector('[name="id"]');
    if (variantInput && !variantInput.__bsubVariantObserverBound) {
      variantInput.__bsubVariantObserverBound = true;

      var observer = new MutationObserver(function () {
        var currentVariantId = getVariantId(form);
        if (currentVariantId !== lastVariantId) {
          lastVariantId = currentVariantId;
          onVariantChanged(form);
        }
      });

      observer.observe(variantInput, {
        attributes: true,
        attributeFilter: ['value']
      });
    }
  }

  function bindAllForms() {
    document.querySelectorAll(MAIN_FORM).forEach(bindForm);
  }

  function reinit(bsub) {
    removeDuplicateSellingPlanInputs();
    bsub.init();
    bindAllForms();
  }

  function start() {
    var tries = 0;

    var timer = setInterval(function () {
      var bsub = window.BOLD && window.BOLD.BsubWidget;

      if (bsub) {
        clearInterval(timer);

        if (patch(bsub)) {
          reinit(bsub);
        } else {
          bindAllForms();
        }

        return;
      }

      if (++tries > 100) {
        clearInterval(timer);
        bindAllForms();
        console.debug('BSUB [dawn-fix]: widget script never appeared; bindings applied without patch.');
      }
    }, 150);

    document.addEventListener('shopify:section:load', function () {
      bindAllForms();
    });

    document.addEventListener('shopify:section:reorder', function () {
      bindAllForms();
    });

    document.addEventListener('shopify:section:select', function () {
      bindAllForms();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();